/*
 * @Date: 2021-03-18 10:57:09
 * @LastEditors  : zhangxu
 * @LastEditTime : 2022-01-20 17:03:07
 * @FilePath     : /front-mvp/src/config/constant.cfg.ts
 */
export const crypto = {
  key: 'DAODAO_MVP_admin',
  iv: 'DAODAO_MVP_admin',
}

export const SEX = {
  1: '男',
  2: '女',
}
export const SEX_MAN = 1

// 来源.
export const SOURCE = {
  1: '机构录入',
  2: '升学测评',
  3: '协助建档',
  4: '平台预约',
  5: '官网注册',
}

// 服务类型.
export const SERVE_TYPE = {
  1: '普通用户',
  2: '志愿卡用户',
  5: '1对1预约用户',
  4: '体验卡用户',
}
export const SERVE_TYPE_VIP = 2
export const SERVE_TYPE_1_V_1 = 3

// 录取结果.
export const ENROLL_RES = {
  0: '-',
  2: '是',
  1: '否',
}
export const ENROLL_RES_UNKNOW = 0
export const ENROLL_RES_NO = 1
export const ENROLL_RES_YES = 2

export const GRADE = {
  '-1': '学龄前',
  1: '一年级',
  2: '二年级',
  3: '三年级',
  4: '四年级',
  5: '五年级',
  6: '六年级',
  7: '初一',
  8: '初二',
  9: '初三',
  10: '高一',
  11: '高二',
  12: '高三',
  100: '成人',
}
export const GRADE_rep = {
  学龄前: -1,
  一年级: 1,
  二年级: 2,
  三年级: 3,
  四年级: 4,
  五年级: 5,
  六年级: 6,
  初一: 7,
  初二: 8,
  初三: 9,
  高一: 10,
  高二: 11,
  高三: 12,
  成人: 100,
}
export const FURTHER_GRADE = {
  1: '一年级',
  2: '二年级',
  3: '三年级',
  4: '四年级',
  5: '五年级',
  6: '六年级',
  7: '初一',
  8: '初二',
  9: '初三',
  10: '高一',
  11: '高二',
  12: '高三',
}

export const NATIONS = [
  '无',
  '汉族',
  '蒙古族',
  '回族',
  '藏族',
  '维吾尔族',
  '苗族',
  '彝族',
  '壮族',
  '布依族',
  '朝鲜族',
  '满族',
  '侗族',
  '瑶族',
  '白族',
  '土家族',
  '哈尼族',
  '哈萨克族',
  '傣族',
  '黎族',
  '傈僳族',
  '佤族',
  '畲族',
  '高山族',
  '拉祜族',
  '水族',
  '东乡族',
  '纳西族',
  '景颇族',
  '柯尔克孜族',
  '土族',
  '达斡尔族',
  '仫佬族',
  '羌族',
  '布朗族',
  '撒拉族',
  '毛南族',
  '仡佬族',
  '锡伯族',
  '阿昌族',
  '普米族',
  '塔吉克族',
  '怒族',
  '乌孜别克族',
  '俄罗斯族',
  '鄂温克族',
  '德昂族',
  '保安族',
  '裕固族',
  '京族',
  '塔塔尔族',
  '独龙族',
  '鄂伦春族',
  '赫哲族',
  '门巴族',
  '珞巴族',
  '基诺族',
]

export const GAOKAOCATEGORY = {
  1: '城镇应届',
  2: '城镇往届',
  3: '农村应届',
  4: '农村往届',
}

export const EDUCATION = {
  1: '高中及以下',
  2: '大专',
  3: '本科',
  4: '研究生',
}

export const EVA_TOPIC_FOR_CONTENT = ['学生', '家长', '学生、家长', '基础普通岗位', '重点核心岗位']

/**
 * 与 Common.EvaTopicItem 中的 stage 字段值对应.
 */
export const EVA_TOPIC_STAGE_TYPE = {
  // 招生评估.
  1: 'recruit',
  2: 'recruit',
  3: 'recruit',

  // 人才评估.
  4: 'assess',
  5: 'assess',
}

export const EVA_TOPIC_FOR_TITLE = {
  recruit: '适合人群',
  further: '适合人群',
  assess: '适应岗位',
}

export const EVA_TOPIC_CONTENT_TITLE = {
  recruit: '评估内容',
  further: '评估内容',
  assess: '评估内容',
}
export const RECRUIT_FURTHER_STATUS_TEXT = {
  0: '未评估',
  1: '评估中',
  2: '已评估',
}
export const ASSESS_STATUS_TEXT = {
  0: '未评估',
  1: '评估中',
  2: '已评估',
}
export const DEPLOMA_ID = {
  5: '专科',
  7: '本科',
  // 13: '不分本专',
  75: '本专兼报',
}

export const WENLI = {
  1: '文科',
  2: '理科',
}

export const CLIENT_STATUS = {
  1: '未完成',
  2: '已完成',
}
export const CLIENT_STATUS_FINISH = 2

export const RELATION_ENUM: string[] = ['父亲', '母亲', '其他亲属']

/**
 * 客户跟进状态.
 */
export const CLIENT_TRACE_TYPE = {
  1: '待跟进', // 默认状态.
  2: '已沟通，无进展',
  3: '已诺访',
  4: '已到访',
  5: '已成交',
  6: '已续费',
}

/**
 * 需要自动缓存机构老师列表数据的菜单.
 */
export const NEED_CACHE_COUNSELOR_ROUTER_KEYS = ['customers', 'service']

/**
 * 批量操作最多支持数据.
 */
export const MAX_BATCH_SIZE = 20

/**
 * 在填报志愿时跳转到完美志愿时需要使用到的相关数据
 */
export const WMZY_TOKEN = {
  sourceTokenKey: 'Authorization',
  cookie_token_key: 'jwtToken',
  cookie_user_id_key: 'uid',
  cookie_domain: 'domain',
}

/**
 * 评估学段筛选映射表
 */
export const STAGE_GROUP = [
  {
    refId: -1,
    desc: '学龄前',
    children: [
      { refId: -1, desc: '学龄前' },
      // { refId: 60, desc: '胎儿期' },
      // { refId: 61, desc: '新生儿期' },
      // { refId: 62, desc: '婴儿期' },
      // { refId: 63, desc: '幼儿期' },
      // { refId: 64, desc: '小班' },
      // { refId: 65, desc: '中班' },
      // { refId: 66, desc: '大班' }
    ],
  },
  {
    refId: 20,
    desc: '小学',
    children: [
      { refId: 1, desc: '一年级' },
      { refId: 2, desc: '二年级' },
      { refId: 3, desc: '三年级' },
      { refId: 4, desc: '四年级' },
      { refId: 5, desc: '五年级' },
      { refId: 6, desc: '六年级' },
    ],
  },
  {
    refId: 30,
    desc: '初中',
    children: [
      { refId: 7, desc: '初一' },
      { refId: 8, desc: '初二' },
      { refId: 9, desc: '初三' },
    ],
  },
  {
    refId: 40,
    desc: '高中',
    children: [
      { refId: 10, desc: '高一' },
      { refId: 11, desc: '高二' },
      { refId: 12, desc: '高三' },
    ],
  },
  {
    refId: 50,
    desc: '大学',
    children: [
      { refId: 13, desc: '大一' },
      { refId: 14, desc: '大二' },
      { refId: 15, desc: '大三' },
      { refId: 16, desc: '大四' },
      { refId: 17, desc: '大五' },
    ],
  },
  {
    refId: 60,
    desc: '成人',
    children: [{ refId: 30, desc: '成人' }],
  },
]

export const MONTH_ICON = [
  '',
  '&#xe627;',
  '&#xe628;',
  '&#xe629;',
  '&#xe62b;',
  '&#xe62a;',
  '&#xe62e;',
  '&#xe62c;',
  '&#xe62f;',
  '&#xe62d;',
  '&#xe630;',
  '&#xe635;',
  '&#xe634;',
  '&#xe631;',
  '&#xe637;',
  '&#xe636;',
  '&#xe639;',
  '&#xe638;',
  '&#xe63c;',
  '&#xe63b;',
  '&#xe640;',
  '&#xe63a;',
  '&#xe63e;',
  '&#xe63f;',
  '&#xe646;',
  '&#xe63d;',
  '&#xe648;',
  '&#xe645;',
  '&#xe649;',
  '&#xe647;',
  '&#xe64a;',
  '&#xe64b;',
]

/**
 * 校验 3-4-4 格式手机号码正则.
 */
export const MOBILE_PHONE_REG = /^1(\d{2})(\s{1})(\d{4})(\s{1})(\d{4})$/

/**
 * 校验手机号的正则
 */
export const MOBILE_PHONE_REG_CONSECUTIVE = /^1(\d){10}$|^(\d){8}$/
/**
 * 字母正则.
 */
export const LETTER_REG = /^[a-zA-Z]{1}$/

/**
 * 数字正则.
 */
export const NUMBER_REG = /^\d{1}$/

/**
 * 中文正则.
 */
export const CHINESE_REG = /^[\u4e00-\u9fa5]{1}$/

/**
 * 沟通状态选择器配置
 */
export const ARCHIVES_STATUS_OPTIONS = [
  {
    value: 1,
    label: '电话沟通',
    children: [
      {
        value: 1,
        label: '有效',
        children: [{ value: 1, label: '电话沟通且是本人' }],
      },
      {
        value: 2,
        label: '无效',
        children: [
          { value: 1, label: '忙音' },
          { value: 2, label: '号码错误' },
          { value: 3, label: '空号' },
        ],
      },
      {
        value: 3,
        label: '待定',
        children: [{ value: 1, label: '无人接听' }],
      },
    ],
  },
  {
    value: 2,
    label: '微信沟通',
    children: [
      {
        value: 1,
        label: '有效',
        children: [{ value: 1, label: '回应沟通' }],
      },
      {
        value: 2,
        label: '无效',
        children: [{ value: 1, label: '拒绝沟通' }],
      },
      {
        value: 3,
        label: '待定',
        children: [{ value: 1, label: '暂无沟通' }],
      },
    ],
  },
  {
    value: 3,
    label: '当面沟通',
    children: [
      {
        value: 1,
        label: '有效',
        children: [{ value: 1, label: '回应沟通' }],
      },
      {
        value: 2,
        label: '无效',
        children: [{ value: 1, label: '拒绝沟通' }],
      },
      {
        value: 3,
        label: '待定',
        children: [{ value: 1, label: '暂无沟通' }],
      },
    ],
  },
]

/**
 * 常规符号正则.
 */
export const ORIGINAL_CHAR_REG = /^[\\/-_=?？:：,，.。、|!%()（）]{1}$/

/**
 * 成长中心 - 用户画像各类型颜色配置.
 */
export const GROW_CENTER_TAG_CONF = {
  0: {
    bgColor: '#FAFAFA',
  },
  1: {
    bgColor: '#FFFBF3',
    tabShadowColor: 'rgba(250, 108, 44, 0.1)',
    borderColor: '#FFEABD',
    tagBgColor: '#FF6900',
    tabBdBgColor: 'linear-gradient(205deg, #FFFFFF 0%, #FFF8E9 100%)',
  },
  2: {
    bgColor: '#FFF1F1',
    tabShadowColor: 'rgba(68, 185, 121, 0.1)',
    borderColor: '#FFD6D2',
    tagBgColor: '#FF8F84',
    tabBdBgColor: 'linear-gradient(226deg, #FFFCF9 0%, #FFECEC 100%)',
  },
  3: {
    bgColor: '#E3FAF7',
    tabShadowColor: 'rgba(44, 136, 250, 0.1)',
    borderColor: '#BBE9D0',
    tagBgColor: '#44B979',
    tabBdBgColor: 'linear-gradient(41deg, #DCFCF8 0%, #EFFFFD 100%)',
  },
  4: {
    bgColor: '#F8FAFF',
    tabShadowColor: 'rgba(12, 101, 53, 0.1)',
    borderColor: '#C0DCFF',
    tagBgColor: '#2C88FA',
    tabBdBgColor: 'linear-gradient(222deg, #F8FAFF 0%, #F1F7FF 100%)',
  },
}

// 成长中心 - 用户画像家庭决策者角色名称.
export const GROW_CENTER_TAG_ROLE_NAME = {
  1: '孩子',
  2: '父亲',
  3: '母亲',
}

// 成长中心 - 用户画像关联评估状态 - 未发起.
export const GROW_CENTER_TAG_STATUS_TEXT_NOT_STARTED = 1
// 成长中心 - 用户画像关联评估状态 - 进行中.
export const GROW_CENTER_TAG_STATUS_TEXT_PROCESSING = 2
// 成长中心 - 用户画像关联评估状态 - 已完成.
export const GROW_CENTER_TAG_STATUS_TEXT_FINISH = 3
// 成长中心 - 用户画像关联评估状态 - 已完成但不可见 .
export const GROW_CENTER_TAG_STATUS_TEXT_UNVISIBLE = 4
// 成长中心 - 用户画像锚点链接路由前缀.
export const ANCHOR_LINK_ROUTER_PREFIX = '/pece/report/pdf-new'

// 导入功能上传文件在 oss 上的区域.
export const UPLOAD_IMPORT_FILE_REGION = 'oss-cn-hangzhou'
// 导入功能上传文件在 oss 上的根目录.
export const UPLOAD_IMPORT_FILE_ROOT_FOLDER = 'enterprise-batch-upload'
// 导入功能上传文件在 oss 上的桶名称.
export const UPLOAD_IMPORT_FILE_BICKET = 'node-file-bucket-new'

// 档案公海导入业务场景标识.
export const OPEN_SEAS_IMPORT_SENCE = 'openSeasImportClient'
// 档案公海导入模板地址.
export const OPEN_SEAES_IMPORT_TEMPLATE_URL =
  'https://storage-node.daodao.pro/enterprise-batch-upload/templates/%E6%89%B9%E9%87%8F%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF-%E6%A1%A3%E6%A1%88%E5%85%AC%E6%B5%B7.xlsx'

// 机构状态 - 已过期.
export const ORG_STATUS_EXPIRED = 5

// 总览报告卡片类型元素配置
export const sceneSampleReportTypeMap = {
  // 图表
  charts: [1, 3],
  // 指标建议
  advice: [1, 3],
  // 指标解释
  explanation: [1, 3],
}
